import step0Info from '../../../share/communication/step0-info'
import step1Products from '../../../share/communication/step1-products'
import step2Actions from '../../../share/communication/step2-actions'
import step3Locations from '../../../share/communication/step3-locations'
import changeHistory from '../../../share/communication/change-history'
import supplierRecallService from '../../../../services/supplier/supplier-recall'
import router from '../../../../router/paths'
import { COMMUNICATION_TYPE, EMPTY_GUID } from '../../../../misc/commons'
import _ from 'lodash'
export const step = [
    { id: '', name: 'Recall', order: 1 },
    { id: '', name: 'Products', order: 2 },
    { id: '',  name: 'Actions', order: 3 },
    { id: '', name: 'Affected Locations', order: 4 }
]

export default {
    data() {
        return {
            loading: false,
            initialLoading: true,
            isAddProduct: false,
            recallStep: step,
            currentStep: 0,
            communicationId: '',
            communicationType: COMMUNICATION_TYPE.RECALL,
            isRemoveButtonEnabled: false,
            recallItem: {
                id: '',
                name: '',
                communicationUID: '',
                type: '',
                communicationDate: '',
                classification: '',
                zNumber: '',
                status: '',
                isUrgent: false,
                isCustomizedContent: false,
                markAs: '',
                supplierId: 0,
                alphaCode: '',
                supplierName: '',
                createdBy: '',
                image: null,
                description: '',
                publicId: '',
                riskToHealth: '',
                typeAction: '',
                categories: [],
                documents: [],
                products: [],
                actions: [],
                meta_data: null
            },
            recallMetaData: {
                recall_types: [],
                recall_categories: [],
                recall_mark_as: [],
                recall_product_fields: [],
                isCustomizedContent: false
            },
            routeFormType: '',
            recallEditPathName: router.supp_Recall_EditItem.name,
            recallNewPathName: router.supp_Recall_NewItem.name,
            recallSupplierListPathName: router.supp_Recall.name,
            changeHistoryModalKey: 0
        }
    },
    components: {
        step0Info,
        step1Products,
        step2Actions,
        step3Locations,
        changeHistory
    },
    computed: {
        isDisabled() {
            if (!this.recallItem || (this.recallItem.id && !['DRAFT', 'OPEN'].includes(this.recallItem.status))) {
                return true
            }
            else {
                return false
            }
        }
    },
    created() {
        if (this.$route.name === this.recallEditPathName && this.$route.params && this.$route.params.id) {
            this.initialLoading = true
            this.fetchRecallItemDetail(this.$route.params.id).then(res => {
                if (res) {
                    this.routeFormType = 'EDIT'
                    if (this.$route.params.step) {
                        this.currentStep = this.$route.params.step
                    }
                    this.initialLoading = false
                }
            })
        } else {
            this.routeFormType = 'CREATE'
            this.fetchRecallMetaDataFromService()
        }
    },
    methods: {
        fetchRecallItemDetail(id) {
            return new Promise((resolve,) => {
                supplierRecallService.communicationDetail(id).then(res => {
                    if (!res.error) {
                        this.recallItem = _.cloneDeep(res.data.d)
                        if (!this.recallItem.id || this.recallItem.id === EMPTY_GUID) {
                            this._showToast('Invalid Recall ID', { variant: 'danger' })
                            this.backToRecallList()
                        } else {
                            this.fetchRecallMetaDataFromRecallItem(this.recallItem)
                            resolve(true)
                        }

                    }
                })
            })

        },
        fetchRecallMetaDataFromRecallItem(item) {
            if (item && item.meta_data) {
                let _lookupValues = item.meta_data.lookup_values
                let _productFields = item.meta_data.product_fields
                this.recallMetaData.isCustomizedContent=item.meta_data.isCustomizedContent
                let _recall_types = _lookupValues.find(x => x.name === 'Recall Type')
                if (_recall_types) {
                    this.recallMetaData.recall_types = _recall_types.list_vals
                }

                let _recall_categories = _lookupValues.find(x => x.name === 'Recall Categories')
                if (_recall_categories) {
                    this.recallMetaData.recall_categories = _recall_categories.list_vals
                }

                let _recall_mark_as = _lookupValues.find(x => x.name === 'Recall Mark As')
                if (_recall_mark_as) {
                    this.recallMetaData.recall_mark_as = _recall_mark_as.list_vals
                    if (this.recallMetaData.recall_mark_as && this.recallMetaData.recall_mark_as.length > 0) {
                        this.recallItem.markAs = this.recallMetaData.recall_mark_as[0].value
                    }
                }

                if (_productFields) {
                    this.recallMetaData.recall_product_fields = _productFields
                }
            }
        },
        fetchRecallMetaDataFromService() {
            supplierRecallService.getRecallMetaData().then(res => {
                if (!res.error) {
                    let _lookupValues = res.data.d.lookup_values
                    this.recallMetaData.isCustomizedContent=res.data.d.isCustomizedContent
                    let _recall_types = _lookupValues.find(x => x.name === 'Recall Type')
                    if (_recall_types) {
                        this.recallMetaData.recall_types = _recall_types.list_vals
                    }

                    let _recall_categories = _lookupValues.find(x => x.name === 'Recall Categories')
                    if (_recall_categories) {
                        this.recallMetaData.recall_categories = _recall_categories.list_vals
                    }

                    let _recall_mark_as = _lookupValues.find(x => x.name === 'Recall Mark As')
                    if (_recall_mark_as) {
                        this.recallMetaData.recall_mark_as = _recall_mark_as.list_vals
                        if (this.recallMetaData.recall_mark_as && this.recallMetaData.recall_mark_as.length > 0) {
                            this.recallItem.markAs = this.recallMetaData.recall_mark_as[0].value
                        }
                    }
                }
            }).finally(() => {
                this.initialLoading = false
            })
        },
        nextStep() {
            if (this.currentStep < 3) {
                this.currentStep += 1
            }
        },
        previousStep() {
            if (this.currentStep > 0) {
                this.currentStep -= 1
            }
        },
        changeStep(step) {
            if (!isNaN(step) && step >= 0 && step <= 3 && this.currentStep !== step) {
                this.currentStep = step
            }
        },
        backToRecallList() {
            this.$router.push({
                name: this.recallSupplierListPathName
            })
        },
        backToViewRecall() {
            if(this.communicationId){
                this.$router.push({ name: 'supp_Recall_ViewItem', params: { id: this.communicationId} })
            } else{
                this.backToRecallList()
            }
        },
        exit() {
            if (['OPEN', 'CLOSED'].includes(this.recallItem.status)) {
                this.showChangeHistoryModal()
            } else {
                this.backToViewRecall()
            }
        },

        showChangeHistoryModal() {
            this.changeHistoryModalKey += 1
            this.$nextTick(() => {
                this.$refs.changeHistoryModal.forceRerender(this.recallItem.id)
            })
        },
        onSavedHistory() {
            this.backToViewRecall()
        },

        saveAndGo(goTypeFn, step = null) {
            if (this.currentStep === 0) {
                this.saveStep0Info(step,goTypeFn.name).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        this.loading = false
                    }
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                })
            } else if (this.currentStep === 1) {
                this.saveStep1Products(goTypeFn.name).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        this.loading = false
                    }
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                })
            } else if (this.currentStep === 2) {
                this.saveStep2Actions(goTypeFn.name).then(resp => {
                    if (resp) {
                        goTypeFn(step)
                        this.loading = false
                    }
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                })
            } else {
                goTypeFn(step)
            }
        },

        saveStep0Info(step,type) {
            if(step===null)
            {step=1}
            return new Promise((resolve, reject) => {
                if (!this.isDisabled) {
                    this.$refs.step0Info.save(type).then(resp => {
                        if (resp) {
                            this.communicationId= resp
                            if (this.routeFormType === 'CREATE') {
                                this.$router.push({
                                    name: this.recallEditPathName,
                                    params: { id: resp, step: step }
                                })
                                resolve(true)
                            } else {
                                this.loading = true
                                this.fetchRecallItemDetail(resp).then(res => {
                                    if (res) {
                                        resolve(true)
                                    }
                                })
                            }
                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(true)
                }
            })
        },
        saveStep1Products(type) {
            return new Promise((resolve, reject) => {
                if (!this.isDisabled) {
                    this.$refs.step1Products.save(type).then(resp => {
                        if (resp) {
                            this.communicationId= resp
                            this.loading = true
                            this.fetchRecallItemDetail(resp).then(res => {
                                if (res) {
                                    resolve(true)
                                }
                            })
                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(true)
                }
            })
        },
        saveStep2Actions(type) {
            return new Promise((resolve, reject) => {
                if (!this.isDisabled) {
                    this.$refs.step2Actions.save(type).then(resp => {
                        if (resp) {
                            this.communicationId= resp
                            this.loading = true
                            this.fetchRecallItemDetail(resp).then(res => {
                                if (res) {
                                    resolve(true)
                                }
                            })
                        }
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(true)
                }
            })
        },
        handleIsEnableUpdate(newVal) {
            this.isRemoveButtonEnabled = newVal
        },
        emitRemoveLocations() {
            this.$refs.step3Locations.removeLocations()
        },
    }
}